import { CornerTicks, Reveal, SectionHeading } from "./decor";
import { ASSETS, MEMBERS } from "../data/siteData";
import { useLang } from "../i18n";

export const Members = () => {
  const { t } = useLang();
  return (
    <section id="lineup" data-testid="lineup-section" className="relative py-24 sm:py-32 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading kicker={t.lineup.kicker} title={t.lineup.title} testId="lineup-heading" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {MEMBERS.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.08}>
              <article
                data-testid={`member-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="relative bg-[#121216] border border-zinc-800 hover:border-red-600/60 hover:shadow-[0_0_24px_rgba(220,38,38,0.2)] hover:-translate-y-1 transition-all duration-300 h-full"
              >
                <CornerTicks className="border-zinc-700" />
                <div className="h-52 overflow-hidden">
                  <img
                    src={m.photo}
                    alt={`${m.name} — ${t.lineup.roles[i]} live`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <p className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-red-500">{t.lineup.roles[i]}</p>
                  <h3 className="font-display text-3xl tracking-wide text-white uppercase mt-2">{m.name}</h3>
                  <p className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-zinc-500 mt-1">{t.lineup.stages[i]}</p>
                  <ul className="mt-4 space-y-1.5 border-t border-zinc-800 pt-4">
                    {m.gear.map((g) => (
                      <li key={g} className="font-mono-tech text-xs text-zinc-400 flex gap-2">
                        <span className="text-red-600">+</span> {g}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-6">
          <article
            id="producer"
            data-testid="producer-card"
            className="relative bg-[#121216] border border-zinc-800 hover:border-red-600/60 hover:shadow-[0_0_24px_rgba(220,38,38,0.2)] transition-all duration-300 grid sm:grid-cols-[220px_1fr] overflow-hidden"
          >
            <CornerTicks className="border-red-600/50" />
            <div className="overflow-hidden">
              <img
                src={ASSETS.producer}
                alt="Mario Spindler — Producer"
                className="w-3/5 mx-auto sm:mx-0 sm:w-full h-auto sm:h-full sm:object-cover sm:object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-6 sm:p-10 flex flex-col justify-center">
              <p className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-red-500">{t.lineup.producerTitle}</p>
              <h3 className="font-display text-3xl sm:text-4xl tracking-wide text-white uppercase mt-2">Mario Spindler</h3>
              <p className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-zinc-500 mt-1">{t.lineup.producerRole}</p>
              <p className="mt-4 text-sm sm:text-base text-zinc-300 leading-relaxed border-t border-zinc-800 pt-4">
                {t.lineup.producerBio}
              </p>
            </div>
          </article>
        </Reveal>
      </div>
    </section>
  );
};
